import SignupFormModel from '../../components/FormBuilder/SignupFormModel';
import FormModel from '../../components/FormBuilder/FormModel';

export default function hasProductsField(
  formDef?: SignupFormModel | FormModel | undefined,
) {
  let field = formDef
    ? formDef.fields.find(
        (field) => String(field.definition.name).toLowerCase() === 'products',
      )
    : null;
  return field != null;
}
